import React from 'react';
import { Search } from 'lucide-react';
export function Hero() {
  return <div className="relative bg-amber-50" data-id="element-176">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <div className="py-16 md:py-24 lg:py-32" data-id="element-178">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-179">
            <div data-id="element-180">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" data-id="element-181">
                Find Your Perfect{' '}
                <span className="text-amber-600" data-id="element-182">Catering Career</span>
              </h1>
              <p className="mt-6 text-xl text-gray-600 max-w-2xl" data-id="element-183">
                Connect with top restaurants, hotels, and catering companies
                looking for talented professionals like you.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-184">
                <a href="#" className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition font-medium text-center" data-id="element-185">
                  Find Jobs
                </a>
                <a href="#" className="bg-white text-amber-600 border border-amber-600 px-6 py-3 rounded-md hover:bg-amber-50 transition font-medium text-center" data-id="element-186">
                  Post a Job
                </a>
              </div>
            </div>
            <div className="hidden lg:block" data-id="element-187">
              <img src="https://images.unsplash.com/photo-1581349485608-9469926a8e5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Chef preparing food" className="rounded-lg shadow-xl object-cover h-96 w-full" data-id="element-188" />
            </div>
          </div>
          <div className="mt-12 bg-white p-4 rounded-lg shadow-md max-w-4xl mx-auto" data-id="element-189">
            <div className="flex flex-col md:flex-row gap-4" data-id="element-190">
              <div className="flex-grow" data-id="element-191">
                <div className="relative" data-id="element-192">
                  <Search className="absolute left-3 top-3 text-gray-400" size={20} data-id="element-193" />
                  <input type="text" placeholder="Job title, keyword, or company" className="pl-10 pr-4 py-3 w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" data-id="element-194" />
                </div>
              </div>
              <div className="flex-grow" data-id="element-195">
                <input type="text" placeholder="City or zip code" className="px-4 py-3 w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" data-id="element-196" />
              </div>
              <button className="bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition font-medium whitespace-nowrap" data-id="element-197">
                Search Jobs
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}